import { IconNamesEnum } from "ngx-bootstrap-icons"
import { SearchCheckboxOption, SearchDateRangeOption, SearchMultiAutoCompleteOption, SearchNumberRangeOption, SearchOption, SearchOptionGroup, SearchOptionType, SearchStringOption, ShowSearchOptionGroup } from "./filtering-search-types"

export const SicSearch = {
    icon: IconNamesEnum.Buildings,
    id: 'sic',
    type: SearchOptionType.multiautocomplete,
    name: 'SIC',
    tableColumn: {
        locked: false,
        sortable: false,
        visible: false,
    },
    required: [],
    items: [],
    filterby: 'role',
    lastResort: true,
    searchServiceParameter: {
        area: 'reference',
        parameters: {
            sic: {
                name: "value",
                type: "stringinput",
            }
        },
        window: {
            start: 1,
            size: 5,
        }
    },
} as SearchMultiAutoCompleteOption

export const StatesCheckbox = {
    icon: IconNamesEnum.Buildings,
    id: 'company_state',
    type: SearchOptionType.checkboxes,
    name: 'State',
    tableColumn: {
        locked: false,
        sortable: false,
        visible: false,
    },
    checkboxes: [        
        {
            name: 'Alaska',
            checked: true,
            value: '46'
        },
        {
            name: 'Alabama',
            checked: true,
            value: '30'
        },
        {
            name: 'Arkansas',
            checked: true,
            value: '34'
        },
        {
            name: 'Arizona',
            checked: true,
            value: '38'
        },
        {
            name: 'California',
            checked: true,
            value: '47'
        },
        {
            name: 'Colorado',
            checked: true,
            value: '39'
        },
        {
            name: 'Connecticut',
            checked: true,
            value: '1'
        },
        {
            name: 'Delaware',
            checked: true,
            value: '22'
        },
        {
            name: 'Florida',
            checked: true,
            value: '23'
        },
        {
            name: 'Georgia',
            checked: true,
            value: '24'
        },
        {
            name: 'Hawaii',
            checked: true,
            value: '48'
        },
        {
            name: 'Iowa',
            checked: true,
            value: '15'
        },
        {
            name: 'Idaho',
            checked: true,
            value: '40'
        },
        {
            name: 'Illinois',
            checked: true,
            value: '10'
        },
        {
            name: 'Indiana',
            checked: true,
            value: '11'
        },
        {
            name: 'Kansas',
            checked: true,
            value: '16'
        },
        {
            name: 'Kentucky',
            checked: true,
            value: '31'
        },
        {
            name: 'Louisiana',
            checked: true,
            value: '35'
        },
        {
            name: 'Massachusetts',
            checked: true,
            value: '3'
        },
        {
            name: 'Maryland',
            checked: true,
            value: '25'
        },
        {
            name: 'Maine',
            checked: true,
            value: '2'
        },
        {
            name: 'Michigan',
            checked: true,
            value: '12'
        },
        {
            name: 'Minnesota',
            checked: true,
            value: '17'
        },
        {
            name: 'Missouri',
            checked: true,
            value: '18'
        },
        {
            name: 'Mississippi',
            checked: true,
            value: '32'
        },
        {
            name: 'Montana',
            checked: true,
            value: '41'
        },
        {
            name: 'North Carolina',
            checked: true,
            value: '26'
        },
        {
            name: 'North Dakota',
            checked: true,
            value: '20'
        },
        {
            name: 'Nebraska',
            checked: true,
            value: '19'
        },
        {
            name: 'New Hampshire',
            checked: true,
            value: '4'
        },
        {
            name: 'New Jersey',
            checked: true,
            value: '7'
        },
        {
            name: 'New Mexico',
            checked: true,
            value: '43'
        },
        {
            name: 'Nevada',
            checked: true,
            value: '42'
        },
        {
            name: 'New York',
            checked: true,
            value: '8'
        },
        {
            name: 'Ohio',
            checked: true,
            value: '13'
        },
        {
            name: 'Oklahoma',
            checked: true,
            value: '36'
        },
        {
            name: 'Oregon',
            checked: true,
            value: '49'
        },
        {
            name: 'Pennsylvania',
            checked: true,
            value: '9'
        },
        {
            name: 'Rhode Island',
            checked: true,
            value: '5'
        },
        {
            name: 'South Carolina',
            checked: true,
            value: '27'
        },
        {
            name: 'South Dakota',
            checked: true,
            value: '21'
        },
        {
            name: 'Tennessee',
            checked: true,
            value: '33'
        },
        {
            name: 'Texas',
            checked: true,
            value: '37'
        },
        {
            name: 'Utah',
            checked: true,
            value: '44'
        },
        {
            name: 'Virginia',
            checked: true,
            value: '28'
        },
        {
            name: 'Vermont',
            checked: true,
            value: '6'
        },
        {
            name: 'Washington',
            checked: true,
            value: '50'
        },
        {
            name: 'Wisconsin',
            checked: true,
            value: '14'
        },
        {
            name: 'West Virginia',
            checked: true,
            value: '29'
        },
        {
            name: 'Wyoming',
            checked: true,
            value: '45'
        }

    ]
} as SearchCheckboxOption

export const industryCheckbox = {
    icon: IconNamesEnum.Buildings,
    id: 'unique_id',
    type: SearchOptionType.checkboxes,
    name: 'Industries',
    checkboxes: [
        {
            name: 'Agriculture, Forestry and Fishing',
            checked: true,

        },
        {
            name: 'Apparel and Textiles',
            checked: true,

        },
        {
            name: 'Automotive',
            checked: true,

        },
        {
            name: 'Aviation',
            checked: true,

        },
        {
            name: 'Banking and Finance',
            checked: true,

        },
        {
            name: 'Chemicals and Allied Products',
            checked: true,

        },
        {
            name: 'Computers and Software',
            checked: true,

        },
        {
            name: 'Construction and Supplies',
            checked: true,

        },
        {
            name: 'Crypto',
            checked: true,

        },
        {
            name: 'Education',
            checked: true,

        },
        {
            name: 'Electronics',
            checked: true,

        },
        {
            name: 'Energy',
            checked: true,

        },
        {
            name: 'Entertainment',
            checked: true,

        },
        {
            name: 'Food, Beverage and Tobacco',
            checked: true,

        },
        {
            name: 'Healthcare and Medical',
            checked: true,

        },
        {
            name: 'Hotel and Gaming',
            checked: true,

        },
        {
            name: 'Insurance',
            checked: true,

        },
        {
            name: 'Manufacturing (Misc.)',
            checked: true,

        },
        {
            name: 'Mining',
            checked: true,

        },
        {
            name: 'Oil and Gas',
            checked: true,

        },
        {
            name: 'Other',
            checked: true,

        },
        {
            name: 'Packaging and Paper',
            checked: true,

        },
        {
            name: 'Publishing and Printing',
            checked: true,

        },
        {
            name: 'Real Estate',
            checked: true,

        },
        {
            name: 'Restaurant',
            checked: true,

        },
        {
            name: 'Retail',
            checked: true,

        },
        {
            name: 'Steel and Metals',
            checked: true,

        },
        {
            name: 'Supermarket',
            checked: true,

        },
        {
            name: 'Telecommunications',
            checked: true,

        },
        {
            name: 'Transportation',
            checked: true,

        },
        {
            name: 'Waste Management / Environmental',
            checked: true,

        },
    ]
} as SearchCheckboxOption

export const marketsCheckbox = {
    icon: IconNamesEnum.Buildings,
    id: 'entity_market',
    type: SearchOptionType.checkboxes,
    name: 'Markets',
    tableColumn: {
        locked: false,
        sortable: false,
        visible: false,
    },
    checkboxes: [
        {
            name: 'Australian',
            checked: true,
            value: '1'
        },
        {
            name: 'Bombay',
            checked: true,
            value: '2'
        },
        {
            name: 'Cboe Canada (f/k/a NEOE)',
            checked: true,
            value: '3'
        },
        {
            name: 'CSE',
            checked: true,
            value: '4'
        },
        {
            name: 'Euronet',
            checked: true,
            value: '5'
        },
        {
            name: 'Frankfurt',
            checked: true,
            value: '6'
        },
        {
            name: 'Hong Kong',
            checked: true,
            value: '7'
        },
        {
            name: 'Indonesia',
            checked: true,
            value: '31'
        },
        {
            name: 'India National',
            checked: true,
            value: '8'
        },
        {
            name: 'Johannesburg',
            checked: true,
            value: '9'
        },
        {
            name: 'Korea',
            checked: true,
            value: '10'
        },
        {
            name: 'LSE',
            checked: true,
            value: '11'
        },
        {
            name: 'Mexico',
            checked: true,
            value: '29'
        },
        {
            name: 'Montreal',
            checked: true,
            value: '12'
        },
        {
            name: 'Nasdaq',
            checked: true,
            value: '13'
        },
        {
            name: 'Nordic Baltic Nasdaq',
            checked: true,
            value: '14'
        },
        {
            name: 'NYSE',
            checked: true,
            value: '15'
        },
        {
            name: 'Oslo',
            checked: true,
            value: '27'
        },
        {
            name: 'OTC',
            checked: true,
            value: '16'
        },
        {
            name: 'Santiago',
            checked: true,
            value: '30'
        },
        {
            name: 'São Paulo',
            checked: true,
            value: '28'
        },
        {
            name: 'Saudi',
            checked: true,
            value: '17'
        },
        {
            name: 'Shanghai',
            checked: true,
            value: '18'
        },
        {
            name: 'Shenzhen',
            checked: true,
            value: '19'
        },
        {
            name: 'Singapore',
            checked: true,
            value: '20'
        },
        {
            name: 'SIZ Swiss',
            checked: true,
            value: '21'
        },
        {
            name: 'Taiwan',
            checked: true,
            value: '22'
        },
        {
            name: 'Tehran',
            checked: true,
            value: '23'
        },
        {
            name: 'Tel Aviv',
            checked: true,
            value: '24'
        },
        {
            name: 'Tokyo',
            checked: true,
            value: '25'
        },
        {
            name: 'Toronto',
            checked: true,
            value: '26'
        },
    ]
} as SearchCheckboxOption

export const industryCheckboxWithID = {
    icon: IconNamesEnum.Buildings,
    id: 'unique_id',
    type: SearchOptionType.checkboxes,
    name: 'Industries',
    checkboxes: [
        {
            name: 'Agriculture, Forestry and Fishing',
            checked: true,
            value: '1'
        },
        {
            name: 'Apparel and Textiles',
            checked: true,
            value: '2'
        },
        {
            name: 'Automotive',
            checked: true,
            value: '3'
        },
        {
            name: 'Aviation',
            checked: true,
            value: '4'
        },
        {
            name: 'Banking and Finance',
            checked: true,
            value: '5'
        },
        {
            name: 'Chemicals and Allied Products',
            checked: true,
            value: '6'
        },
        {
            name: 'Computers and Software',
            checked: true,
            value: '7'
        },
        {
            name: 'Construction and Supplies',
            checked: true,
            value: '8'
        },
        {
            name: 'Crypto',
            checked: true,
            value: '9'
        },
        {
            name: 'Education',
            checked: true,
            value: '10'
        },
        {
            name: 'Electronics',
            checked: true,
            value: '11'
        },
        {
            name: 'Energy',
            checked: true,
            value: '12'
        },
        {
            name: 'Entertainment',
            checked: true,
            value: '13'
        },
        {
            name: 'Food, Beverage and Tobacco',
            checked: true,
            value: '14'
        },
        {
            name: 'Healthcare and Medical',
            checked: true,
            value: '15'
        },
        {
            name: 'Hotel and Gaming',
            checked: true,
            value: '16'
        },
        {
            name: 'Insurance',
            checked: true,
            value: '17'
        },
        {
            name: 'Manufacturing (Misc.)',
            checked: true,
            value: '18'
        },
        {
            name: 'Mining',
            checked: true,
            value: '19'
        },
        {
            name: 'Oil and Gas',
            checked: true,
            value: '20'
        },
        {
            name: 'Other',
            checked: true,
            value: '21'
        },
        {
            name: 'Packaging and Paper',
            checked: true,
            value: '22'
        },
        {
            name: 'Publishing and Printing',
            checked: true,
            value: '23'
        },
        {
            name: 'Real Estate',
            checked: true,
            value: '24'
        },
        {
            name: 'Restaurant',
            checked: true,
            value: '25'
        },
        {
            name: 'Retail',
            checked: true,
            value: '26'
        },
        {
            name: 'Steel and Metals',
            checked: true,
            value: '27'
        },
        {
            name: 'Supermarket',
            checked: true,
            value: '28'
        },
        {
            name: 'Telecommunications',
            checked: true,
            value: '29'
        },
        {
            name: 'Transportation',
            checked: true,
            value: '30'
        },
        {
            name: 'Waste Management / Environmental',
            checked: true,
            value: '31'
        },
    ]
} as SearchCheckboxOption

export const dollarRange = {
    icon: IconNamesEnum.CurrencyDollar,
    id: 'range',
    type: SearchOptionType.checkboxes,
    name: 'Range',
    checkboxes: [
        {
            name: '$0-$50,000',
            value: '0-50000',
            checked: true,
        },
        {
            name: '$50,001 to $100,000',
            value: '50001-100000',
            checked: true,
        },
        {
            name: '$100,001 to $500,000',
            value: '100001-500000',
            checked: true,
        },
        {
            name: '$500,001 to $1 million',
            value: '500001-1000000',
            checked: true,
        },
        {
            name: '$1 million to $10 million',
            value: '1000001-10000000',
            checked: true,
        },
        {
            name: '$10 million to $50 million',
            value: '10000001-50000000',
            checked: true,
        },
        {
            name: '$50 million to $100 million',
            value: '50000001-100000000',
            checked: true,
        },
        {
            name: '$100 million to $500 million',
            value: '100000001-500000000',
            checked: true,
        },
        {
            name: '$500 million to $1 billion',
            value: '500000001-1000000000',
            checked: true,
        },
        {
            name: '$1 billion to $10 billion',
            value: '1000000001-10000000000',
            checked: true,
        },
        {
            name: '$10 billion to $50 billion',
            value: '10000000001-50000000000',
            checked: true,
        },
        {
            name: 'More than $50 billion',
            value: '50000000001',
            checked: true,
        }
    ]
} as SearchCheckboxOption

export const revenueRange = {
    icon: IconNamesEnum.CurrencyDollar,
    id: 'revenue_range',
    type: SearchOptionType.checkboxes,
    name: 'Revenues Range',
    checkboxes: [
        {
            name: '$0 to $500,000',
            value: '0-500000',
            checked: true,
        },
        {
            name: '$500,000 to $1 million',
            value: '500001-1000000',
            checked: true,
        },
        {
            name: '$1 million to $2.5 million',
            value: '1000001-2500000',
            checked: true,
        },
        {
            name: '$2.5 million to $5 million',
            value: '2500001-5000000',
            checked: true,
        },
        {
            name: '$5 million to $10 million',
            value: '5000001-10000000',
            checked: true,
        },
        {
            name: '$10 million to $20 million',
            value: '10000001-20000000',
            checked: true,
        },
        {
            name: '$20 million to $50 million',
            value: '20000001-50000000',
            checked: true,
        },
        {
            name: '$50 million to $100 million',
            value: '50000001-100000000',
            checked: true,
        },
        {
            name: '$100 million to $500 million',
            value: '100000001-500000000',
            checked: true,
        },
        {
            name: '$500 million to $1 billion',
            value: '500000001-1000000000',
            checked: true,
        },
        {
            name: '$1 billion to $10 billion',
            value: '1000000001-10000000000',
            checked: true,
        },
        {
            name: '$10 billion to $50 billion',
            value: '10000000001-50000000000',
            checked: true,
        },
        {
            name: 'More than $50 billion',
            value: '50000000001',
            checked: true,
        }

    ]
} as SearchCheckboxOption

export const employeesRange = {
    icon: IconNamesEnum.People,
    id: 'employees_range',
    type: SearchOptionType.checkboxes,
    name: 'Employees Range',
    checkboxes: [
        {
            name: '1-4',
            checked: true,
        },
        {
            name: '5-9',
            checked: true,
        },
        {
            name: '10-19',
            checked: true,
        },
        {
            name: '20-49',
            checked: true,
        },
        {
            name: '50-99',
            checked: true,
        },
        {
            name: '100-249',
            checked: true,
        },
        {
            name: '250-499',
            checked: true,
        },
        {
            name: '500-999',
            checked: true,
        },
        {
            name: '1000-4,999',
            checked: true,
        },
        {
            name: '5,000-9,999',
            checked: true,
        },
        {
            name: '10,000+',
            checked: true,
        }

    ]
} as SearchCheckboxOption

export const creditorsRange = {
    icon: IconNamesEnum.People,
    id: 'creditors_range',
    type: SearchOptionType.checkboxes,
    name: 'Creditors Range',
    tableColumn: {
        visible: true,
    },
    checkboxes: [
        {
            name: '1-49',
            checked: true,
        },
        {
            name: '50-99',
            checked: true,
        },
        {
            name: '100-199',
            checked: true,
        },
        {
            name: '200-999',
            checked: true,
        },
        {
            name: '1,000-5,000',
            checked: true,
        },
        {
            name: '5,001-10,000',
            checked: true,
        },
        {
            name: '10,001-25,000',
            checked: true,
        },
        {
            name: '25,001-50,000',
            checked: true,
        },
        {
            name: '50,001-100,000',
            checked: true,
        },
        {
            name: 'Over 100,000',
            checked: true,
        }
    ]
} as SearchCheckboxOption

export const CaseFilingDate = {
    icon: IconNamesEnum.Calendar4Range,
    id: 'case_filing_date',
    type: SearchOptionType.daterange,
    name: 'Petition Date',
    tableColumn: {
        visible: false,
    },
    minDate: new Date(),
    maxDate: new Date(),

} as SearchDateRangeOption

export const situationTypes = {
    icon: IconNamesEnum.List,
    id: 'situation_type',
    type: SearchOptionType.checkboxes,
    name: 'Type',
    checkboxes: [
        {
            name: 'Bankruptcy Case',
            value: 'bankruptcy',
            checked: true,
            conditionalOptions: {
                icon: IconNamesEnum.Briefcase,
                id: 'case_include_type',
                name: 'Add Non-Priority',
                type: SearchOptionType.checkboxes,
                numberChecked: 0,
                alwaysSend: true,
                visible: false,
                tableColumn: {
                    visible: false,
                    alwaysHidden: true
                },
                checkboxes: [
                    {
                        name: 'Include Non-priority Cases',
                        value: 'non-priority',
                        checkedDefault: false,
                        checked: false,
                    },
                    {
                        name: 'Include Joint Adminstered Cases',
                        value: 'JACs',
                        checkedDefault: false,
                        checked: false,
                    },
                ]
            }
        },
        {
            name: 'Distressed',
            value: 'distressed',
            checked: true,
        },
    ],
    tableColumn: {
        visible: true
    }
} as SearchCheckboxOption

export const organisationName = {
    icon: IconNamesEnum.BuildingCheck,
    id: 'organization',
    name: 'Organization',
    type: SearchOptionType.multiautocomplete,
    required: [],
    items: [],
    filterby: 'role',
    tableColumn: {
        visible: true,
    },
    searchServiceParameter: {
        area: 'organizations/autocomplete',
        parameters: {
            name: {
                name: "Organization",
                type: "stringinput",
                format: 'autocomplete',
                returndata: 'brief',
            }
        },
        window: {
            start: 1,
            size: 5,
        }
    },
} as SearchMultiAutoCompleteOption

export const organisationName2 = {
    icon: IconNamesEnum.InputCursorText,
    id: 'name',
    name: 'Organization Name',
    type: SearchOptionType.multiautocomplete,
    required: [],
    tableColumn: {
        visible: true,
    },
    lastResort: true,
    items: [],
    filterby: 'role',
    searchServiceParameter: {
        area: 'organizations/autocomplete',
        parameters: {
            name: {
                name: "name",
                type: "stringinput",
                format: 'autocomplete',
                returndata: 'brief',
            }
        },
        window: {
            start: 1,
            size: 5,
        }
    },
}


export const SituationName = {
    icon: IconNamesEnum.InputCursorText,
    id: 'entity_name',
    name: 'Situation Name',
    type: SearchOptionType.multiautocomplete,
    required: [],
    lastResort: true,
    tableColumn: {
        visible: true,
    },
    items: [],
    filterby: 'role',
    searchServiceParameter: {
        area: 'situations',
        parameters: {
            entity_name: {
                name: "name",
                type: "stringinput",
                format: 'autocomplete',
                returndata: 'brief',
            }
        },
        window: {
            start: 1,
            size: 5,
        }
    },
} as SearchMultiAutoCompleteOption


export const personName = {
    icon: IconNamesEnum.People,
    id: 'people',
    name: 'People',
    type: SearchOptionType.multiautocomplete,
    required: [],
    items: [],
    filterby: 'role',
    searchServiceParameter: {
        area: 'people/autocomplete',
        parameters: {
            name: {
                name: "Person",
                type: "stringinput",
                format: 'autocomplete',
                returndata: 'brief',
            }
        },
        window: {
            start: 1,
            size: 5,
        }
    },
} as SearchMultiAutoCompleteOption

export const AdvisorRoles = {
    icon: IconNamesEnum.At,
    id: 'involvement_subtype_lookupID',
    name: 'Advisor Roles',
    type: SearchOptionType.checkboxes,
    checkboxes: [
        {
            name: 'Financial',
            value: '21',
            checked: true,
        },
        {
            name: 'Legal',
            value: '16',
            checked: true,
        },
        {
            name: 'Other',
            value: '26',
            checked: true,
        },
    ]
} as SearchCheckboxOption

export const GroupType = {
    icon: IconNamesEnum.Briefcase,
    id: 'group_type',
    name: 'Group Type',
    type: SearchOptionType.checkboxes,
    checkboxes: [
        {
            name: 'Ad Hoc Group',
            value: 'group-adhoc',
            checked: true,
        },
        {
            name: 'Board Group',
            value: 'group-board',
            checked: true,
        },
        {
            name: 'Class Action/Litigation Group',
            value: 'group-classactionlitigation',
            checked: true,
        },
        {
            name: 'Official Group',
            value: 'group-official',
            checked: true,
        },
        {
            name: 'Sale/Finance SPV Group',
            value: 'group-salefinancespv',
            checked: true,
        },
        {
            name: 'Trust Group',
            value: 'group-trust',
            checked: true,
        },

    ]
} as SearchCheckboxOption

export const GroupDebtType = {
    icon: IconNamesEnum.Briefcase,
    id: 'group_debt_type',
    name: 'Group Debt Type',
    type: SearchOptionType.checkboxes,
    checkboxes: [
        {
            name: 'Equity Group',
            value: 'group-equity',
            checked: true,
        },
        {
            name: 'Labor/Retiree Group',
            value: 'group-laborretiree',
            checked: true,
        },

        {
            name: 'Landlord Group',
            value: 'group-landlord',
            checked: true,
        },
        {
            name: 'Litigation Claims Group',
            value: 'group-litigationclaims',
            checked: true,
        },
        {
            name: 'Other Group',
            value: 'group-other',
            checked: true,
        },
        {
            name: 'Secured Group',
            value: 'group-secured',
            checked: true,
        },
        {
            name: 'Trade Group',
            value: 'group-trade',
            checked: true,
        },
        {
            name: 'Unsecured Group',
            value: 'group-unsecured',
            checked: true,
        },

    ]
} as SearchCheckboxOption

export const InstrumentType = {
    icon: IconNamesEnum.CurrencyDollar,
    id: 'instrument_type',
    name: 'Type',
    tableColumn: {
        locked: false,
        sortable: true,
        visible: true,
    },
    type: SearchOptionType.checkboxes,
    active: false,
    selected: false,
    visible: true,
    numberChecked: 0,
    checkboxes: [
        {
            name: 'Bond/Note',
            value: 'Bond/Note',
            checked: true,
        },
        {
            name: 'Capital Lease',
            value: 'Capital Lease',
            checked: true,
        },
        {
            name: 'Equity',
            value: 'Equity',
            checked: true,
        },
        {
            name: 'Intercompany Note',
            value: 'Intercompany Note',
            checked: true,
        },
        {
            name: 'Promissory Note',
            value: 'Promissory Note',
            checked: true,
        },
        {
            name: 'Loan',
            value: 'Loan',
            checked: true,
        },
        {
            name: 'Other',
            value: 'Other',
            checked: true,
        },
    ]
} as SearchCheckboxOption

export const InstrumentSecurity = {
    icon: IconNamesEnum.Lock,
    id: 'instrument_security',
    name: 'Level of Security',
    tableColumn: {
        locked: false,
        sortable: true,
        visible: true,
    },
    type: SearchOptionType.checkboxes,
    active: false,
    selected: false,
    visible: true,
    numberChecked: 0,
    checkboxes: [
        {
            name: 'Secured',
            value: 'Secured',
            checked: true,
        },
        {
            name: 'Unsecured',
            value: 'Unsecured',
            checked: true,
        },
        {
            name: 'N/A',
            value: 'N/A',
            checked: true,
        },
    ]
} as SearchCheckboxOption



export const ClaimType = {
    icon: IconNamesEnum.Briefcase,
    id: 'claim_type',
    name: 'Claim Type',
    type: SearchOptionType.checkboxes,
    checkboxes: [
        {
            name: 'CVA Litigation [37 Plaintiffs]',
            value: 'CVA Litigation [37 Plaintiffs]',
            checked: true,
        },
        {
            name: 'Employee Wages / Benefits',
            value: 'Employee Wages / Benefits',
            checked: true,
        },
        {
            name: 'Guarantee',
            value: 'Guarantee',
            checked: true,
        },
        {
            name: 'Insurance',
            value: 'Insurance',
            checked: true,
        },
        {
            name: 'Lease / Rent',
            value: 'Lease / Rent',
            checked: true,
        },
        {
            name: 'Litigation',
            value: 'Litigation',
            checked: true,
        },
        {
            name: 'Other',
            value: 'Other',
            checked: true,
        },
        {
            name: 'Professional Services / Fees',
            value: 'Professional Services / Fees',
            checked: true,
        },
        {
            name: 'Rebate / Refund / Warranty',
            value: 'Rebate / Refund / Warranty',
            checked: true,
        },
        {
            name: 'Royalty / JIB / Working Interest',
            value: 'Royalty / JIB / Working Interest',
            checked: true,
        },
        {
            name: 'Taxes',
            value: 'Taxes',
            checked: true,
        },
        {
            name: 'Trade',
            value: 'Trade',
            checked: true,
        },
        {
            name: 'Undisclosed',
            value: 'Undisclosed',
            checked: true,
        },
        {
            name: 'Union / Pension',
            value: 'Union / Pension',
            checked: true,
        },
    ]
} as SearchCheckboxOption

export const StatutoryOtherRoles = {
    icon: IconNamesEnum.At,
    id: 'involvement_subtype_lookupID_statutory',
    name: 'Statutory/Other Roles',
    type: SearchOptionType.checkboxes,
    checkboxes: [
        {
            name: ' Chapter 15 - Foreign Representative/Administrator',
            value: '181',
            checked: true,

        },
        {
            name: 'Other - Non-Debtor Affiliate',
            value: '231',
            checked: true,
        },
        {
            name: 'Plan - Foreign Representative/Administrator',
            value: '181',
            checked: true,
        },
        {
            name: 'Plan - GUC Trustee',
            value: '290',
            checked: true,
        },
        {
            name: 'Plan - Liquidating Trustee',
            value: '206',
            checked: true,
        },
        {
            name: 'Plan - Litigation Trustee',
            value: '211',
            checked: true,
        },
        {
            name: 'Plan - New Board',
            value: '293',
            checked: true,
        },
        {
            name: 'Plan - Plan Administrator',
            value: '226',
            checked: true,
        },

        {
            name: 'Statutory - Chapter 7 Trustee',
            value: '156',
            checked: true,
        },
        {
            name: 'Statutory - Chapter 11 Trustee',
            value: '161',
            checked: true,
        },
        {
            name: 'Statutory - Consumer Privacy Ombudsman',
            value: '166',
            checked: true,
        },
        {
            name: 'Statutory - Examiner',
            value: '151',
            checked: true,
        },
        {
            name: 'Statutory - Fee Examiner',
            value: '176',
            checked: true,
        },
        {
            name: 'Statutory - Future Claims Representative',
            value: '216',
            checked: true,
        },
        {
            name: 'Statutory - Mediator',
            value: '266',
            checked: true,
        },
        {
            name: 'Statutory - Other',
            value: '267',
            checked: true,
        },
        {
            name: 'Statutory - Patient Care Ombudsman',
            value: '146',
            checked: true,
        },
        {
            name: 'Statutory - Subchapter V Trustee',
            value: '305',
            checked: true,
        },
        {
            name: 'Statutory - U.S. Trustee',
            value: '186',
            checked: true,
        },
    ]
} as SearchCheckboxOption

export const CourtAppointeeRoles = {
    icon: IconNamesEnum.At,
    id: 'involvement_subtype_lookupID_court',
    name: 'Court Appointees Roles',
    type: SearchOptionType.checkboxes,
    checkboxes: [
        {
            name: 'Chapter 7 Trustee',
            value: '156',
            checked: true,
        },
        {
            name: 'Chapter 11 Trustee',
            value: '161',
            checked: true,
        },
        {
            name: 'Consumer Privacy Ombudsman',
            value: '166',
            checked: true,
        },
        {
            name: 'Examiner',
            value: '151',
            checked: true,
        },
        {
            name: 'Fee Examiner',
            value: '176',
            checked: true,
        },
        {
            name: 'Future Claims Representative',
            value: '216',
            checked: true,
        },
        {
            name: 'Mediator',
            value: '266',
            checked: true,
        },
        {
            name: 'Other',
            value: '267',
            checked: true,
        },
        {
            name: 'Patient Care Ombudsman',
            value: '146',
            checked: true,
        },
        {
            name: 'Subchapter V Trustee',
            value: '305',
            checked: true,
        },

        {
            name: 'U.S. Trustee',
            value: '186',
            checked: true,
        },
    ]
} as SearchCheckboxOption

export const DebtorRoles = {
    icon: IconNamesEnum.At,
    id: 'involvement_subtype_lookupID_debtor',
    name: 'Distressed Entity/Debtor Roles',
    type: SearchOptionType.checkboxes,
    checkboxes: [
        {
            name: 'Joint Admistrated Case Debtor',
            value: '201',
            checked: true,

        },
        {
            name: 'Lead Debtor',
            value: '196',
            checked: true,

        },
        {
            name: 'Reorganized Debtor',
            value: '221',
            checked: true,

        },

    ]
} as SearchCheckboxOption

export const PartyInInterestRoles = {
    icon: IconNamesEnum.At,
    id: 'involvement_subtype_lookupID_partyinterest',
    name: 'Creditor/Party in Interest Roles',
    type: SearchOptionType.checkboxes,
    checkboxes: [
        {
            name: 'Debt/Equity - Administrative Agent',
            value: '86',
            checked: true,

        },
        {
            name: 'Debt/Equity - Collateral Agent',
            value: '96',
            checked: true,

        },
        {
            name: 'Debt/Equity - Equity Holder',
            value: '71',
            checked: true,

        },
        {
            name: 'Debt/Equity - Funded Debt Holder (Note/Loan)',
            value: '66',
            checked: true,
        },
        {
            name: 'Debt/Equity - Indenture Trustee',
            value: '91',
            checked: true,
        },
        {
            name: 'Debt/Equity - Instrument Counterparty',
            value: '287',
            checked: true,
        },
        {
            name: 'Debt/Equity - Involuntary Petitioner',
            value: '236',
            checked: true,

        },
        {
            name: 'Debt/Equity - Lender',
            value: '284',
            checked: true,

        },
        {
            name: 'Debt/Equity - Private Equity Sponsor',
            value: '76',
            checked: true,

        },
        {
            name: 'Debt/Equity - Trade Creditor',
            value: '81',
            checked: true,

        },
        {
            name: 'Debt/Equity - Underwriter/Arranger',
            value: '251',
            checked: true,

        },
        {
            name: 'Operation - Competitor',
            value: '126',
            checked: true,
        },
        {
            name: 'Operation - Government/Regulatory',
            value: '241',
            checked: true,
        },
        {
            name: 'Operation - Insurance/Surety',
            value: '246',
            checked: true,
        },
        {
            name: 'Operation - Joint Venture Party',
            value: '121',
            checked: true,
        },
        {
            name: 'Operation - Labor Union/Retirement or Pension Fund',
            value: '191',
            checked: true,
        },
        {
            name: 'Operation - Landlord',
            value: '106',
            checked: true,
        },
        {
            name: 'Operation - Litigant',
            value: '101',
            checked: true,
        },
        {
            name: 'Operation - Other Creditor/Party in Interest',
            value: '171',
            checked: true,
        },
        {
            name: 'Operation - Significant Vendor/Contract Counterparty',
            value: '116',
            checked: true,
        },
        {
            name: 'Operation - Utility Company',
            value: '111',
            checked: true,
        },
        {
            name: 'Sale Party - Asset Sale Party/Advisor',
            value: '302',
            checked: true,
        },
        {
            name: 'Sale Party - Bidder (Non-Stalking Horse)',
            value: '136',
            checked: true,
        },
        {
            name: 'Sale Party - Plan Sale Purchaser',
            value: '299',
            checked: true,
        },
        {
            name: 'Sale Party - Plan Sponsor',
            value: '141',
            checked: true,
        },
        {
            name: 'Sale Party - Stalking Horse Bidder',
            value: '131',
            checked: true,
        },
        {
            name: 'Top Creditor',
            value: '281',
            checked: true,
        },
    ]
} as SearchCheckboxOption

export const FilingType = {
    icon: IconNamesEnum.Check2All,
    id: 'case_filing_type',
    name: 'Filing Type',
    type: SearchOptionType.checkboxes,
    numberChecked: 0,
    checkboxes: [
        {
            name: 'Chapter 7',
            value: '7',
            checked: true,
        },
        {
            name: 'Chapter 9',
            value: '9',
            checked: true,
        },
        {
            name: 'Chapter 11',
            value: '11',
            checked: true,
        },
        {
            name: 'Chapter 12',
            value: '12',
            checked: true,
        },
        {
            name: 'Chapter 15',
            value: '15',
            checked: true,
        },
    ],
    tableColumn: {

    }
} as SearchCheckboxOption


export const CaseDebtorType = {
    icon: IconNamesEnum.Check2All,
    id: 'debtorbusiness',
    name: 'Debtor Business',
    type: SearchOptionType.checkboxes,
    numberChecked: 0,
    checkboxes: [
        {
            name: 'Health Care Business',
            value: 'health_care_business',
            checked: true,
        },
        {
            name: 'Single Asset Real Estate',
            value: 'single_asset_real_estate',
            checked: true,
        },
        {
            name: 'Railroad',
            value: 'railroad',
            checked: true,
        },
        {
            name: 'Stockbroker',
            value: 'stockbroker',
            checked: true,
        },
        {
            name: 'Commodity Broker',
            value: 'commodity_broker',
            checked: true,
        },
        {
            name: 'Clearing Bank',
            value: 'clearing_bank',
            checked: true,
        },
        {
            name: 'Other',
            value: 'business_none_of_the_above',
            checked: true,
        },
    ],
    tableColumn: {
    }
}

export const BankruptcyChapter = {
    icon: IconNamesEnum.List,
    type: SearchOptionType.checkboxes,
    id: 'bankruptcy_chapter',
    name: 'Bankruptcy Chapter',
    checkboxes: [
        {
            name: 'Prepackaged',
            value: 'Prepackaged',
            checked: true,
        },
        {
            name: 'Pre-Arranged',
            value: 'Pre-Arranged',
            checked: true,
        },
        {
            name: 'Free-Fall',
            value: 'Free-Fall',
            checked: true,
        },
        {
            name: 'N/A',
            value: 'N/A',
            checked: true,
        },
    ]
} as SearchCheckboxOption



export const CaseStatus = {
    icon: IconNamesEnum.Briefcase,
    type: SearchOptionType.checkboxes,
    id: 'case_status',
    name: 'Case Status',
    checkboxes: [
        {
            name: 'Pending',
            checked: true,
        },
        {
            name: 'Confirmed',
            checked: true,
        },
        {
            name: 'Effective',
            checked: true,
        },
        {
            name: 'Converted',
            checked: true,
        },
        {
            name: 'Terminated',
            checked: true,
        },
        {
            name: 'Dismissed',
            checked: true,
        },
    ]
} as SearchCheckboxOption

export const CourtName = {
    icon: IconNamesEnum.InputCursorText,
    id: 'court_name',
    name: 'Court',
    lastResort: true,
    type: SearchOptionType.multiautocomplete,
    required: [],
    items: [],
    filterby: 'role',
    searchServiceParameter: {
        area: 'organizations/autocomplete',
        parameters: {
            name: {
                name: "court",
                type: "stringinput",
                format: 'autocomplete',
                returndata: 'brief',
            }
        },
        window: {
            start: 1,
            size: 5,
        }
    },
} as SearchMultiAutoCompleteOption

export const JudgeName = {
    icon: IconNamesEnum.InputCursorText,
    id: 'judge_name',
    name: 'Judge',
    lastResort: true,
    type: SearchOptionType.multiautocomplete,
    required: [],
    items: [],
    filterby: 'role',
    tableColumn: {
        sortable: false,
    },
    searchServiceParameter: {
        area: 'organizations/autocomplete',
        parameters: {
            name: {
                name: "judge",
                type: "stringinput",
                format: 'autocomplete',
                returndata: 'brief',
            }
        },
        window: {
            start: 1,
            size: 5,
        }
    },
} as SearchMultiAutoCompleteOption


export const CaseIncludeType = {
    icon: IconNamesEnum.Briefcase,
    id: 'case_include_type',
    name: 'Add Non-Priority',
    type: SearchOptionType.checkboxes,
    numberChecked: 0,
    selected: true,
    alwaysSend: true,
    tableColumn: {
        visible: false,
        alwaysHidden: true
    },
    checkboxes: [
        {
            name: 'Include Non-priority Cases',
            value: 'non-priority',
            checkedDefault: false,
            checked: false,
        },
        {
            name: 'Include Joint Adminstered Cases',
            value: 'JACs',
            checkedDefault: false,
            checked: false,
        },
    ]
} as SearchCheckboxOption

export const DistressedSituationReason = {
    icon: IconNamesEnum.Check2All,
    id: 'distressed_situation_reasons',
    name: 'Reason for Distress',
    type: SearchOptionType.checkboxes,
    depends: {
        "situation_type": ['distressed']
    },

    tableColumn: {
        visible: false,
        sortable: false,
    },
    checkboxes: [
        {
            name: 'Asset Sale',
            value: '1001',
            checked: true,
        },
        {
            name: 'Balance Sheet Restructuring',
            value: '1002',
            checked: true,
        },
        {
            name: 'Bankruptcy Warning',
            value: '1003',
            checked: true,
        },
        {
            name: 'BDC Distress',
            value: '1004',
            checked: true,
        },
        {
            name: 'Borrowing Base Redetermination',
            value: '1005',
            checked: true,
        },
        {
            name: 'Creditor Talks',
            value: '1006',
            checked: true,
        },
        {
            name: 'Debt Amendment',
            value: '1007',
            checked: true,
        },
        {
            name: 'Debt Buyback/Redemption',
            value: '1008',
            checked: true,
        },
        {
            name: 'Debt Default',
            value: '1009',
            checked: true,
        },
        {
            name: 'Debt Drawdown',
            value: '1010',
            checked: true,
        },
        {
            name: 'Debt Forbearance',
            value: '1011',
            checked: true,
        },
        {
            name: 'Debt Issuance',
            value: '1012',
            checked: true,
        },
        {
            name: 'Debt Refinance',
            value: '1013',
            checked: true,
        },
        {
            name: 'Delisting',
            value: '1014',
            checked: true,
        },
        {
            name: 'Distress Trading',
            value: '1015',
            checked: true,
        },
        {
            name: 'Entered RSA/TSA',
            value: '1016',
            checked: true,
        },
        {
            name: 'Exchange Offer',
            value: '1017',
            checked: true,
        },
        {
            name: 'Financial Performance',
            value: '1018',
            checked: true,
        },
        {
            name: 'Foreign Court Restructuring',
            value: '1019',
            checked: true,
        },
        {
            name: 'Going Concern Warning',
            value: '1020',
            checked: true,
        },
        {
            name: 'Hired Advisors',
            value: '1021',
            checked: true,
        },
        {
            name: 'Investigation (Internal/SEC)',
            value: '1022',
            checked: true,
        },
        {
            name: 'Key Management Change',
            value: '1023',
            checked: true,
        },
        {
            name: 'Litigation',
            value: '1024',
            checked: true,
        },
        {
            name: 'M&A',
            value: '1025',
            checked: true,
        },
        {
            name: 'Miscellaneous',
            value: '1026',
            checked: true,
        },
        {
            name: 'New Equity Investment',
            value: '1027',
            checked: true,
        },
        {
            name: 'Operational Reorg/Reduction',
            value: '1028',
            checked: true,
        },
        {
            name: 'Public Notice',
            value: '1029',
            checked: true,
        },
        {
            name: 'Rating Assignment',
            value: '1030',
            checked: true,
        },
        {
            name: 'Receiver',
            value: '1031',
            checked: true,
        },
        {
            name: 'Reverse Stock Split',
            value: '1032',
            checked: true,
        },
        {
            name: 'Stock Offering',
            value: '1033',
            checked: true,
        },
        {
            name: 'Strategic Alternatives Review',
            value: '1034',
            checked: true,
        },
        {
            name: 'Winddown',
            value: '1035',
            checked: true,
        },
        {
            name: 'Workforce Reduction',
            value: '1036',
            checked: true,
        },
    ]
} as SearchCheckboxOption


export const SituationDate = {
    icon: IconNamesEnum.Calendar4Range,
    id: 'situational_date',
    type: SearchOptionType.daterange,
    name: 'Date',
    tableColumn: {
        visible: true,
    },
    minDate: new Date(),
    maxDate: new Date(),

} as SearchDateRangeOption

export const MarketTickers = {
    icon: IconNamesEnum.Check2All,
    type: SearchOptionType.showoptiongroup,
    name: 'Market Tickers',
    id: 'market_tickers',
    tableColumn: {
        sortable: false,
        visible: false,
        alwaysHidden: true,
        showInDownloads: true,
    },
    depends: {
        hide: ['always']
    }
} as ShowSearchOptionGroup


export const SituationsGroup = {
    groupName: "Situations",
    visible: true,
    colour: '#009640',
    options: [
        SituationDate,
        SituationName,
        {
            ...StatesCheckbox,            
            name: 'Debtor Location',            
        } as SearchCheckboxOption,  
        {
            icon: IconNamesEnum.InputCursorText,
            id: 'organization_name',
            name: 'Organization Name',
            type: SearchOptionType.multiautocomplete,
            required: [],
            tableColumn: {
                visible: false,
                alwaysHidden: true
            },
            lastResort: true,
            items: [],
            filterby: 'role',
            searchServiceParameter: {
                area: 'organizations/autocomplete',
                parameters: {
                    name: {
                        name: "name",
                        type: "stringinput",
                        format: 'autocomplete',
                        returndata: 'brief',
                    }
                },
                window: {
                    start: 1,
                    size: 5,
                }
            },
        } as SearchMultiAutoCompleteOption,                      
        MarketTickers,
        {
            icon: IconNamesEnum.InputCursorText,
            id: 'person_name',
            name: 'Person Name',
            type: SearchOptionType.multiautocomplete,
            required: [],
            tableColumn: {
                sortable: false,
                visible: false,
                alwaysHidden: true
            },
            lastResort: true,
            items: [],
            filterby: 'role',
            searchServiceParameter: {
                area: 'people/autocomplete',
                parameters: {
                    name: {
                        name: "name",
                        type: "stringinput",
                        format: 'autocomplete',
                        returndata: 'brief',
                    }
                },
                window: {
                    start: 1,
                    size: 5,
                }
            },
        } as SearchMultiAutoCompleteOption,
        {
            ...situationTypes,
            tableColumn: {
                visible: true,
            },
        } as SearchCheckboxOption,
        {
            ...industryCheckbox,
            id: 'case_industry',
            name: 'Industries',
            tableColumn: {
                visible: true,
            },
        } as SearchCheckboxOption,
        SicSearch,
        {
            ...marketsCheckbox,
            name: 'Markets',
            tableColumn: {
                locked: false,
                sortable: false,
                visible: false,
            },
        } as SearchCheckboxOption,
        {
            icon: IconNamesEnum.Briefcase,
            id: 'company_type',
            name: 'Company Type',
            type: SearchOptionType.checkboxes,
            numberChecked: 0,
            checkboxes: [
                {
                    name: 'Public Company',
                    value: 'Public Company',
                    checked: true,
                },
                {
                    name: 'Private Company',
                    value: 'Private Company',
                    checked: true,
                },
                {
                    name: 'Angel-Backed Company',
                    value: 'Angel-Backed Company',
                    checked: true,
                },
                {
                    name: 'BDC Financed Company',
                    value: 'BDC Financed Company',
                    checked: true,
                },
                {
                    name: 'Corporate-Backed Company',
                    value: 'Corporate-Backed Company',
                    checked: true,
                },
                {
                    name: 'de-SPAC',
                    value: 'de-SPAC',
                    checked: true,
                },
                {
                    name: 'EB-5 Project',
                    value: 'EB-5 Project',
                    checked: true,
                },
                {
                    name: 'Employee-Owned Company',
                    value: 'Employee-Owned Company',
                    checked: true,
                },
                {
                    name: 'Family-Owned Company',
                    value: 'Family-Owned Company',
                    checked: true,
                },
                {
                    name: 'Municipal Debt-Financed Company',
                    value: 'Municipal Debt-Financed Company',
                    checked: true,
                },
                {
                    name: 'Non-Profit Company',
                    value: 'Non-Profit Company',
                    checked: true,
                },
                {
                    name: 'PE-Backed Company',
                    value: 'PE-Backed Company',
                    checked: true,
                },
                {
                    name: 'Post-Reorg Company',
                    value: 'Post-Reorg Company',
                    checked: true,
                },
                {
                    name: 'State-Owned / Sovereign Funds-Backed',
                    value: 'State-Owned / Sovereign Funds-Backed',
                    checked: true,
                },
                {
                    name: 'VC-Backed Company',
                    value: 'VC-Backed Company',
                    checked: true,
                }
            ]
        } as SearchCheckboxOption,
        {
            ...structuredClone(dollarRange),
            id: 'assets_range',
            name: 'Assets Range',
            tableColumn: {
                visible: true,
            },

        } as SearchCheckboxOption,
        {
            ...structuredClone(dollarRange),
            id: 'liabilities_range',
            name: 'Liabilities Range',
            tableColumn: {
                visible: true,
            },
        } as SearchCheckboxOption,
        {
            ...revenueRange,
            tableColumn: {
                visible: true,
            },
        },
        {
            ...employeesRange,
            tableColumn: {
                visible: true,
            },
        },
        {
            ...creditorsRange,
            tableColumn: {
                visible: true,
            },
        },
        {
            icon: IconNamesEnum.Check2All,
            name: 'With Asset Sales',
            id: 'with_assets_sales',
            tableColumn: {
                alwaysHidden: true,
                visible: false,
                showInDownloads: false
            },
            type: SearchOptionType.checkboxes,
            numberChecked: 0,
            checkboxes: [
                {
                    name: 'Yes',
                    value: 'Yes',
                    checked: true,
                },
                {
                    name: 'No',
                    value: 'No',
                    checked: true,
                }
            ]
        } as SearchCheckboxOption,
    ]
}


export const SituationsGroupNoCompanyType = {
    groupName: "Situations",
    visible: true,
    colour: '#009640',
    options: [
        SituationDate,
        SituationName,
        {
            icon: IconNamesEnum.InputCursorText,
            id: 'organization_name',
            name: 'Organization Name',
            tableColumn: {
                locked: false,
                sortable: false,
                visible: false
            },
            type: SearchOptionType.multiautocomplete,
            active: false,
            lastResort: true,
            selected: false,
            visible: true,
            required: [],
            items: [],
            filterby: 'role',
            searchServiceParameter: {
                area: 'organizations/autocomplete',
                parameters: {
                    name: {
                        name: "name",
                        type: "stringinput",
                        format: 'autocomplete',
                        returndata: 'brief',
                    }
                },
                window: {
                    start: 1,
                    size: 5,
                }
            },
        } as SearchMultiAutoCompleteOption,
        {
            ...StatesCheckbox,            
            name: 'Debtor Location',            
        } as SearchCheckboxOption, 
        MarketTickers,
        {
            icon: IconNamesEnum.InputCursorText,
            id: 'person_name',
            name: 'Person Name',
            type: SearchOptionType.multiautocomplete,
            required: [],
            tableColumn: {
                visible: false,
                alwaysHidden: true
            },
            lastResort: true,
            items: [],
            filterby: 'role',
            searchServiceParameter: {
                area: 'people/autocomplete',
                parameters: {
                    name: {
                        name: "name",
                        type: "stringinput",
                        format: 'autocomplete',
                        returndata: 'brief',
                    }
                },
                window: {
                    start: 1,
                    size: 5,
                }
            },
        } as SearchMultiAutoCompleteOption,
        {
            ...situationTypes,
            tableColumn: {
                visible: true,
            },
        } as SearchCheckboxOption,
        {
            ...industryCheckbox,
            id: 'case_industry',
            name: 'Industries',
            tableColumn: {
                visible: true,
            },
        } as SearchCheckboxOption,
        SicSearch,
        {
            ...marketsCheckbox,
            name: 'Markets',
            tableColumn: {
                locked: false,
                sortable: false,
                visible: false,
            },
        } as SearchCheckboxOption,

        {
            ...structuredClone(dollarRange),
            id: 'assets_range',
            name: 'Assets Range',
            tableColumn: {
                visible: true,
            },

        } as SearchCheckboxOption,
        {
            ...structuredClone(dollarRange),
            id: 'liabilities_range',
            name: 'Liabilities Range',
            tableColumn: {
                visible: true,
            },
        } as SearchCheckboxOption,
        {
            ...revenueRange,
            tableColumn: {
                visible: true,
            },
        },
        {
            ...employeesRange,
            tableColumn: {
                visible: true,
            },
        },
        {
            ...creditorsRange,
            tableColumn: {
                visible: true,
            },
        },
        {
            icon: IconNamesEnum.Check2All,
            name: 'With Asset Sales',
            id: 'with_assets_sales',
            tableColumn: {
                alwaysHidden: true,
                visible: false,
                showInDownloads: false
            },
            type: SearchOptionType.checkboxes,
            numberChecked: 0,
            checkboxes: [
                {
                    name: 'Yes',
                    value: 'Yes',
                    checked: true,
                },
                {
                    name: 'No',
                    value: 'No',
                    checked: true,
                }
            ]
        } as SearchCheckboxOption,
    ]
}

export const BankruptcyCaseGroupBasic = {
    groupName: "Bankruptcy Case",
    visible: true,
    colour: '#9BCFB2',
    depends: {
        "situation_type": ['bankruptcy']
    },
    options: [
        FilingType,
        {
            icon: IconNamesEnum.Calendar4Range,
            id: 'case_confirmation_date',
            type: SearchOptionType.daterange,
            name: 'Confirmation Date',
            tableColumn: {
                visible: false,
            },
            minDate: new Date(),
            maxDate: new Date(),

        } as SearchDateRangeOption,
        CaseStatus,
        CourtName,
        JudgeName,
    ]
}




export const BankruptcyCaseGroupMinusCompanyType = {
    groupName: "Bankruptcy Case",
    visible: true,
    colour: '#9BCFB2',
    depends: {
        "situation_type": ['bankruptcy']
    },
    options: [
        CaseFilingDate,
        {
            icon: IconNamesEnum.Calendar4Range,
            id: 'case_confirmation_date',
            type: SearchOptionType.daterange,
            name: 'Confirmation Date',
            tableColumn: {
                visible: false,
            },
            minDate: new Date(),
            maxDate: new Date(),

        } as SearchDateRangeOption,
        {
            icon: IconNamesEnum.Calendar4Range,
            id: 'case_effective_date',
            type: SearchOptionType.daterange,
            name: 'Effective Date',
            tableColumn: {
                visible: false,
            },
            minDate: new Date(),
            maxDate: new Date(),

        } as SearchDateRangeOption,
        FilingType,
        {
            icon: IconNamesEnum.Check2All,
            id: 'subchapter_v',
            name: 'Subchapter V',
            type: SearchOptionType.checkboxes,
            numberChecked: 0,
            checkboxes: [
                {
                    name: 'Yes',
                    value: 'Yes',
                    checked: true,
                },
                {
                    name: 'No',
                    value: 'No',
                    checked: true,
                }
            ]
        } as SearchCheckboxOption,
        CaseDebtorType,
        CaseStatus,
        CourtName,
        JudgeName,
        {
            icon: IconNamesEnum.Check2All,
            type: SearchOptionType.switchoptiongroup,
            tableColumn: {
                visible: false,
                alwaysHidden: true,
                showInDownloads: false
            },
            name: 'Has Retentions',
            id: 'with_retentions',
            value: 'yes'
        },
        {
            icon: IconNamesEnum.Check2All,
            type: SearchOptionType.switchoptiongroup,
            tableColumn: {
                visible: false,
                sortable: false,
            },
            name: 'Chapter 22/33',
            id: 'with_chapter22',
            value: 'yes'
        }
    ]
}

export const BankruptcyCaseGroup = {
    groupName: "Bankruptcy Case",
    visible: true,
    colour: '#9BCFB2',
    depends: {
        "situation_type": ['bankruptcy']
    },
    options: [
        BankruptcyCaseGroupMinusCompanyType,
        {
            icon: IconNamesEnum.Briefcase,
            id: 'company_type',
            name: 'Company Type',
            type: SearchOptionType.checkboxes,
            numberChecked: 0,
            checkboxes: [
                {
                    name: 'Public Company',
                    value: 'Public Company',
                    checked: true,
                },
                {
                    name: 'Private Company',
                    value: 'Private Company',
                    checked: true,
                },
                {
                    name: 'Angel-Backed Company',
                    value: 'Angel-Backed Company',
                    checked: true,
                },
                {
                    name: 'Corporate-Backed Company',
                    value: 'Corporate-Backed Company',
                    checked: true,
                },
                {
                    name: 'de-SPAC',
                    value: 'de-SPAC',
                    checked: true,
                },
                {
                    name: 'EB-5 Project',
                    value: 'EB-5 Project',
                    checked: true,
                },
                {
                    name: 'Employee-Owned Company',
                    value: 'Employee-Owned Company',
                    checked: true,
                },
                {
                    name: 'Family-Owned Company',
                    value: 'Family-Owned Company',
                    checked: true,
                },
                {
                    name: 'Municipal Debt-Financed Company',
                    value: 'Municipal Debt-Financed Company',
                    checked: true,
                },
                {
                    name: 'Non-Profit Company',
                    value: 'Non-Profit Company',
                    checked: true,
                },
                {
                    name: 'PE-Backed Company',
                    value: 'PE-Backed Company',
                    checked: true,
                },
                {
                    name: 'Post-Reorg Company',
                    value: 'Post-Reorg Company',
                    checked: true,
                },
                {
                    name: 'State-Owned / Sovereign Funds-Backed',
                    value: 'State-Owned / Sovereign Funds-Backed',
                    checked: true,
                },
                {
                    name: 'VC-Backed Company',
                    value: 'VC-Backed Company',
                    checked: true,
                }
            ]
        } as SearchCheckboxOption
    ]
}

export function hideOptionGroupFromTableSelector(group: SearchOptionGroup): SearchOptionGroup {
    let newGroup = structuredClone(group)
    newGroup.options = newGroup.options.map((option: SearchOption) => {
        option.tableColumn = {
            ...option.tableColumn,
            alwaysHidden: true
        }
        return option
    })
    return newGroup
}

export function hideOptionGroupTableColumns(group: SearchOptionGroup, names: string[]): SearchOptionGroup {
    let newGroup = structuredClone(group)
    newGroup.options = newGroup.options.map((option: SearchOption) => {
        option.tableColumn = {
            ...option.tableColumn,
            visible: !names.includes(option.id)
        }
        return option
    })
    return newGroup
}

export const dollarRangeConsideration = {
    icon: IconNamesEnum.CurrencyDollar,
    id: 'dollar_range',
    type: SearchOptionType.numberrange,
    name: 'Dollar Range',
    minValue: 1,
    maxValue: 1000000,
    options: {
        floor: 1,
        ceil: 1000000,
        logScale: true,
    },
    prefix: '$',
    suffix: '',
} as SearchNumberRangeOption

export const dollarRangeWithNA = {
    id: 'range_amount_na',
    name: 'Range Amount NA',
    icon: IconNamesEnum.CurrencyDollar,
    type: SearchOptionType.numberrange,
    minValue: 1,
    maxValue: 1000000,
    tableColumn: {

        visible: false,
    },
    options: {
        floor: 1,
        ceil: 1000000,
        logScale: true,
    },
    orPercent: true,
    orPercentOptions: {
        showPercent: false,
        minValue: 0,
        maxValue: 100
    },
    checkboxes: [
        {
            name: 'Include unknown',
            value: 'N/A',
            checked: false,
        },
    ],
    prefix: '$',
    suffix: '',
} as SearchNumberRangeOption

export const CaseNameAutocomplete =
    {
        icon: IconNamesEnum.InputCursorText,
        id: 'case_name',
        name: 'Case name',

        lastResort: true,
        type: SearchOptionType.multiautocomplete,
        required: [],
        tableColumn: {
            visible: true,
        },
        items: [],
        filterby: 'role',
        searchServiceParameter: {
            area: 'situations',
            parameters: {
                entity_name_retentions: {
                    name: "name",
                    type: "stringinput",
                    format: 'autocomplete',
                    returndata: 'brief',
                }
            },
            window: {
                start: 1,
                size: 5,
            }
        },
    } as SearchMultiAutoCompleteOption

export const AllCaseNameAutocomplete =
    {
        icon: IconNamesEnum.InputCursorText,
        id: 'case_name',
        name: 'Case name',

        lastResort: true,
        type: SearchOptionType.multiautocomplete,
        required: [],
        tableColumn: {
            visible: true,
        },
        items: [],
        filterby: '',
        searchServiceParameter: {
            area: 'situations/autocomplete',
            parameters: {
                name: {
                    name: "case_name",
                    type: "stringinput",
                    format: 'autocomplete',
                    returndata: 'brief',
                }
            },
            window: {
                start: 1,
                size: 5,
            }
        },
    } as SearchMultiAutoCompleteOption

export const CaseGroup =
{
    groupName: "Case",
    colour: '#136481',
    options: [
        {
            icon: IconNamesEnum.InputCursorText,
            id: 'case_name',
            name: 'Case name',

            lastResort: true,
            type: SearchOptionType.multiautocomplete,
            required: [],
            tableColumn: {
                visible: true,
            },
            items: [],
            filterby: 'role',
            searchServiceParameter: {
                area: 'situations',
                parameters: {
                    entity_name: {
                        name: "name",
                        type: "stringinput",
                        format: 'autocomplete',
                        returndata: 'brief',
                    }
                },
                window: {
                    start: 1,
                    size: 5,
                }
            },
        },
        FilingType,
        CaseFilingDate,
        {
            ...StatesCheckbox,            
            name: 'Debtor Location',            
        } as SearchCheckboxOption,  
        MarketTickers,
        {
            ...structuredClone(dollarRange),
            id: 'assets_range',
            name: 'Assets Range',
            tableColumn: {
                visible: true,
            },

        } as SearchCheckboxOption,
        {
            ...structuredClone(dollarRange),
            id: 'liabilities_range',
            name: 'Liabilities Range',
            tableColumn: {
                visible: true,
            },
        } as SearchCheckboxOption,
        {
            ...revenueRange,
            tableColumn: {
                visible: true,
            },
        },
        {
            ...industryCheckbox,
            id: 'case_industry',
            name: 'Industries',
        } as SearchCheckboxOption,
        SicSearch,
        CourtName,
        JudgeName,
    ]
}

export const LegalAdvisorRoles = {
    icon: IconNamesEnum.At,
    id: 'involvement_role_lookupID',
    name: 'Legal Advisor Roles',
    type: SearchOptionType.checkboxes,
    tableColumn: {
        alwaysHidden: true,
        locked: false,
        sortable: true,
        visible: false,
    },
    active: false,
    selected: false,
    visible: true,
    numberChecked: 0,
    checkboxes: [
        {
            name: 'Bankruptcy Counsel',
            value: '156',
            checked: true,
        },
        {
            name: 'Conflicts/Special Counsel',
            value: '196',
            checked: true,
        },
        {
            name: 'Foreign Counsel',
            value: '261',
            checked: true,
        },
        {
            name: 'General Corporate Counsel',
            value: '166',
            checked: true,
        },
        {
            name: 'Industry-Specific Counsel',
            value: '191',
            checked: true,
        },
        {
            name: 'Insurance Counsel',
            value: '266',
            checked: true,
        },
        {
            name: 'IP Counsel',
            value: '186',
            checked: true,
        },
        {
            name: 'Litigation Counsel',
            value: '171',
            checked: true,
        },
        {
            name: 'Local Bankruptcy Counsel',
            value: '161',
            checked: true,
        },
        {
            name: 'Other',
            value: '282',
            checked: true,
        },
        {
            name: 'Real Estate Counsel',
            value: '181',
            checked: true,
        },
        {
            name: 'Tax Counsel',
            value: '176',
            checked: true,
        },
    ]
} as SearchCheckboxOption

export const FinancialAdvisorRoles = {
    icon: IconNamesEnum.At,
    id: 'involvement_role_lookupID',
    name: 'Financial Advisor Roles',
    type: SearchOptionType.checkboxes,
    tableColumn: {
        alwaysHidden: true,
        locked: false,
        sortable: true,
        visible: false,
    },
    active: false,
    selected: false,
    visible: true,
    numberChecked: 0,
    checkboxes: [
        {
            name: 'Accountant/Auditor/Tax Advisor',
            value: '211',
            checked: true,
        },
        {
            name: 'Financial Advisor',
            value: '201',
            checked: true,
        },
        {
            name: 'Investment Banker',
            value: '206',
            checked: true,
        },
        {
            name: 'Management Services/Personnel',
            value: '276',
            checked: true,
        },
        {
            name: 'Other',
            value: '283',
            checked: true,
        },
        {
            name: 'Restructuring/Turnaround/Operational Advisor',
            value: '221',
            checked: true,
        },
        {
            name: 'Valuation Services/Expert',
            value: '271',
            checked: true,
        },
    ]
} as SearchCheckboxOption


export const OtherAdvisorRoles = {
    icon: IconNamesEnum.At,
    id: 'involvement_role_lookupID',
    name: 'Other Advisor Roles',
    type: SearchOptionType.checkboxes,
    tableColumn: {
        alwaysHidden: true,
        locked: false,
        sortable: true,
        visible: false,
    },
    active: false,
    selected: false,
    visible: true,
    numberChecked: 0,
    checkboxes: [
        {
            name: 'Appraiser',
            value: '236',
            checked: true,
        },
        {
            name: 'Auctioneer',
            value: '241',
            checked: true,
        },
        {
            name: 'Claims/Notice Agent',
            value: '216',
            checked: true,
        },
        {
            name: 'Consultant',
            value: '246',
            checked: true,
        },
        {
            name: 'Expert Witness',
            value: '251',
            checked: true,
        },
        {
            name: 'Information Agent',
            value: '281',
            checked: true,
        },
        {
            name: 'Liquidator/Broker',
            value: '256',
            checked: true,
        },
        {
            name: 'Ordinary Course Professional (OCP)',
            value: '231',
            checked: true,
        },
        {
            name: 'Other',
            value: '284',
            checked: true,
        },
        {
            name: 'PR/Marketing',
            value: '226',
            checked: true,
        },
    ]
} as SearchCheckboxOption

export const DocumentTypes = {
    icon: IconNamesEnum.Buildings,
    id: 'documenttypes',
    name: 'Document Types',
    type: SearchOptionType.checkboxes,
    checkboxes: [
        // {name: "Company Logo", value: '1'},
        { name: "363 Sale/Asset Purchase Agreement", value: '3' },
        { name: "Adversary Proceedings", value: '23' },
        { name: "Affidavit/Declaration", value: '9' },
        { name: "Bankruptcy Petition", value: '4' },
        { name: "Claims Register", value: '33' },
        { name: "Committees", value: '17' },
        { name: "Confirmations/Emergences", value: '18' },
        // {name: "Company Announcement", value: '31'},
        { name: "Conversions", value: '20' },
        { name: "Court Audio File", value: '35' },
        { name: "Dismissals", value: '19' },
        // {name: "Daily Filings", value: '2'},
        { name: "DIP Financing Documents", value: '5' },
        { name: "Disclosure Statements", value: '6' },
        // {name: "Examiner Reports", value: '22'},
        // {name: "Exclusivity Extensions", value: '7'},
        { name: "Exit Financing", value: '8' },
        { name: "KEIP and KERP Motions", value: '10' },
        // {name: "Feature Report", value: '25'},
        { name: "Final Fees", value: '26' },
        { name: "Hearing Notice/Agenda", value: '42' },
        // {name: "Form 10-K", value: '27'},
        // {name: "Form 8-K", value: '28'},
        // {name: "Form 20-F", value: '29'},
        // {name: "Form 6-k", value: '30'},
        // {name: "Form 10-Q", value: '37'},
        // {name: "Form 424", value: '38'},
        { name: "Mailing", value: '40' },
        { name: "Monthly Operating Report (MOR)", value: '11' },
        { name: "Notice of Appearance/Pro Hac Vice", value: '39' },
        { name: "Objection", value: '12' },
        { name: "Other", value: '13' },
        { name: "Plans", value: '14' },
        // {name: "Plan Summary", value: '24'},
        { name: "Retentions", value: '16' },

        // *TODO retags
        { name: "Rule 2019", value: '34' },
        { name: "Rule 2019 Economic Interest Table", value: '36' },
        { name: "Stipulations", value: '21' },
        { name: "Schedules", value: '32' },
        { name: "Service", value: '41' },
    ]
} as SearchCheckboxOption

export const SECDocumentTypes = {
    icon: IconNamesEnum.Buildings,
    id: 'formname',
    name: 'Form',
    type: SearchOptionType.checkboxes,
    tableColumn: {
        visible: true,
    },
    checkboxes: [
        {
            name: "6-K Report of foreign private issuer",
            value: "6-K",
        },
        {
            name: "8-K Current Report §13/§15(d)",
            value: "8-K",
        },
        {
            name: "10-K Annual Report",
            value: "10-K",
        },
        {
            name: "10-Q Quarterly Report",
            value: "10-Q",
        },
    ]
} as SearchCheckboxOption

export const SECDocumentTypesLookup = {
    icon: IconNamesEnum.Buildings,
    id: 'formname',
    type: SearchOptionType.multiautocomplete,
    name: 'Form',
    tableColumn: {
        visible: true,
    },
    required: [],
    items: [
    ],
    filterby: 'role',
    lastResort: true,
    searchServiceParameter: {
        area: 'reference',
        parameters: {
            secform: {
                name: "value",
                type: "stringinput",
            }
        },
        window: {
            start: 1,
            size: 5,
        }
    },
} as SearchMultiAutoCompleteOption


export const HearingStatus = {
    icon: IconNamesEnum.Check2All,
    id: 'hearing_status',
    name: 'Hearing Status',
    type: SearchOptionType.checkboxes,
    lastResort: true,
    selected: true,
    tableColumn: {
        visible: true
    },
    checkboxes: [
        {
            name: 'Scheduled',
            checked: true
        },
        {
            name: 'Adjourned',
            checked: false,
            checkedDefault: false,
        },
        {
            name: 'Cancelled',
            checked: false,
            checkedDefault: false,
        }
    ]
} as SearchCheckboxOption


export const HearingType = {
    icon: IconNamesEnum.Check2All,
    id: 'hearing_type',
    name: 'Hearing Type',
    type: SearchOptionType.checkboxes,
    lastResort: true,
    tableColumn: {
        visible: true,
        runningOrder: 9
    },
    checkboxes: [
        {
            name: 'Confirmation',
        },
        {
            name: 'First Day',
        },
        {
            name: 'Second Day',
        },
        {
            name: 'Omnibus',
        },
        {
            name: 'Status Conference',
        },
    ]
} as SearchCheckboxOption

export const exhibitCheckboxes = [
        "EX-1: Letter re Change in Certifying Accountant" ,
        "EX-2: Acquisition and Reorganization Plans" ,
        "EX-3: Articles of Incorporation and By-Laws" ,
        "EX-4: Instruments Defining the Rights of Security Holders" ,
        "EX-5: Opinion re Legality" ,
        "EX-6: Opinion re Discount on Capital Shares" ,
        "EX-7: Opinion re Liquidation Preferences" ,
        "EX-8: Opinion re Tax Matters" ,
        "EX-9: Voting Trust Agreement" ,
        "EX-10: Material Contracts" ,
        "EX-11: Statement re Computation of Per Share Earnings" ,
        "EX-12: Statements re Computation of Ratios" ,
        "EX-13: Annual report of Security Holders" ,
        "EX-14: Code of Ethics" ,
        "EX-15: letter re Unaudited Interim Financial Information" ,
        "EX-16: Letter re Change in Certifying Accountant " ,
        "EX-17: Letter re Director Resignation" ,
        "EX-18: Letter re Change in Accounting Principles" ,
        "EX-19 Reports Furnished to Security Holders" ,
        "EX-20: Other Documents of Statement to Security Holders   " ,
        "EX-21: Subsidiaries of the Registrant" ,
        "EX-22: Published Report Regarding Matters Submitted to Vote of Security Holders" ,
        "EX-23: Consents of Experts and Counsel" ,
        "EX-24: Power of Attorney" ,
        "EX-25: Statement of Eligibility of Trustee" ,
        "EX-26: Invitations for Competitive Bid or Issuer Purchases of Equity Securities" ,
        "EX-27: Financial Data Schedule" ,
        "EX-28: Information from Reports Furnished to State Insurance Regulatory Authority" ,
        "EX-31: Rule 13a-14(a)/15d-14(a) Certifications" ,
        "EX-32: Section 1350 Certifications 6" ,
        "EX-33: Report on assessment of compliance with servicing criteria for asset-backed issuers" ,
        "EX-34: Attestation report on assessment of compliance with servicing criteria for asset-backed securities" ,
        "EX-35: Servicer compliance statement" ,
        "EX-36: Depositor Certification for shelf offerings of asset-backed securities" ,
        "EX-95: Mine Safety Disclosure Exhibit" ,
        "EX-96: Technical report summary" ,
        "EX-97: Policy Relating to Recovery of Erroneously Awarded Compensation" ,
        "EX-98: Reports, opinions, or appraisals in de-SPAC transactions" ,
        "EX-99: Additional Exhibits" ,
        "EX-100: XBRL-Related Documents" ,
        "EX-101: Interactive Data File" ,
        "EX-102: Asset Data File" ,
        "EX-103: Asset Related Documents" ,
        "EX-104: Cover Page Interactive Data File" ,
        "EX-106: Static Pool PDF" ,
        "EX-107: Filing Fee Table" ,
    ]


export const SECDocumentSearchGroup = {
    groupName: "Document",
    visible: true,
    colour: '#136481',
    options: [
        {
            icon: IconNamesEnum.Calendar4Range,
            id: 'content',
            type: SearchOptionType.stringinput,
            name: 'Content',
            lastResort: true,
            searchString: '',
            matchingOption: 'phrase',
            tableColumn: {
                visible: true,
            },
            matchingOptionTypes: {
                exactPhrase: true,
                allWords: true,
                someWords: true,
                booleanMode: true,
            },
            checkboxes: [
                { name: "Description", value: 'description', checked: true },
                { name: "Content", value: 'content', checked: true },
            ]
        } as SearchStringOption,
        {
            icon: IconNamesEnum.Calendar4Range,
            id: 'itemupdatedat',
            type: SearchOptionType.daterange,
            name: 'Date',
            minDate: new Date(),
            maxDate: new Date(),
            tableColumn: {
                visible: true,
            },

        } as SearchDateRangeOption,
        SECDocumentTypesLookup,
        {
            icon: IconNamesEnum.Check2,
            id: 'exhibit_type',
            type: SearchOptionType.checkboxes,
            name: 'Exhibit Types',
            lastResort: true,
            tableColumn: {
                visible: true
            },
            checkboxes: exhibitCheckboxes.map((exhibit:string) => {
                return {
                    name: exhibit,
                    value: exhibit.split(":")[0].replace("EX-", ""),
                    checked: true,
                }
            })
        } as SearchCheckboxOption
    ]
}
